import { atom } from "jotai";
// We will create this model file in the next step
import { ChatMessage } from "../../models/chat/ChatMessage";

export const chatMessagesState = atom([]);